import { keyMirror } from 'utils/keyMirror';

export const ActionTypes = keyMirror(
  {
    LOAD_LAYOUT_DETAILS_METADATA: null,
    UPDATE_REUSABLE_LAYOUT_TAGS: null,
  },
  'LayoutDetailsWindow',
);
